import type { SVGProps } from 'react';

export type SenoIconName =
  | 'skripsi'
  | 'project-new'
  | 'bahan'
  | 'pedoman'
  | 'referensi'
  | 'jurnal'
  | 'data'
  | 'dokumentasi'
  | 'lampiran'
  | 'revisi'
  | 'ai'
  | 'parafrase'
  | 'konsistensi'
  | 'validasi'
  | 'sinkronisasi'
  | 'history'
  | 'snapshot'
  | 'docx'
  | 'pdf'
  | 'download'
  | 'finalisasi'
  | 'payment'
  | 'license'
  | 'security'
  | 'admin';

const paths: Record<SenoIconName, React.ReactNode> = {
  skripsi: (
    <>
      <path d="M7 3h8l3 3v15H7z" />
      <path d="M15 3v4h4M10 10h5M10 14h5M10 18h3" />
      <path d="M5 6H3v15h11" />
    </>
  ),
  'project-new': (
    <>
      <path d="M5 4h9l4 4v12H5z" />
      <path d="M14 4v5h5M12 12v6M9 15h6" />
    </>
  ),
  bahan: (
    <>
      <path d="M3 7.5h7l2 2h9v10.5H3z" />
      <path d="M5 7.5V5h6l2 2.5" />
      <path d="M8 14h8M8 17h5" />
    </>
  ),
  pedoman: (
    <>
      <path d="M5 4h11a3 3 0 0 1 3 3v13H8a3 3 0 0 0-3 1z" />
      <path d="M5 4v17M9 8h6M9 12h6M9 16h4" />
    </>
  ),
  referensi: (
    <>
      <path d="M4 5h6a3 3 0 0 1 3 3v12a3 3 0 0 0-3-3H4z" />
      <path d="M20 5h-4a3 3 0 0 0-3 3M16 10h3M16 14h3" />
    </>
  ),
  jurnal: (
    <>
      <path d="M6 3h12v18H6z" />
      <path d="M9 3v18M12 8h3M12 12h3M12 16h3" />
      <circle cx="9" cy="6" r=".5" fill="currentColor" />
    </>
  ),
  data: (
    <>
      <path d="M5 19V9M10 19V5M15 19v-7M20 19V3" />
      <path d="M3 21h19" />
    </>
  ),
  dokumentasi: (
    <>
      <path d="M4 6h5l2-2h6l2 2h2v14H4z" />
      <circle cx="12.5" cy="13" r="4" />
      <path d="M18 9h.01" />
    </>
  ),
  lampiran: <path d="M9 8v8a3 3 0 0 0 6 0V6a5 5 0 0 0-10 0v11a7 7 0 0 0 14 0V9" />,
  revisi: (
    <>
      <path d="M4 18.5V21h2.5L18 9.5 14.5 6z" />
      <path d="m13 7.5 3.5 3.5M18 4l2 2M5 5h6M5 9h4" />
    </>
  ),
  ai: (
    <>
      <path d="M12 3c.8 3.2 2.8 5.2 6 6-3.2.8-5.2 2.8-6 6-.8-3.2-2.8-5.2-6-6 3.2-.8 5.2-2.8 6-6z" />
      <path d="M19 15c.4 1.6 1.4 2.6 3 3-1.6.4-2.6 1.4-3 3-.4-1.6-1.4-2.6-3-3 1.6-.4 2.6-1.4 3-3zM5 14c.3 1.2 1 2 2.2 2.3C6 16.6 5.3 17.4 5 18.6c-.3-1.2-1-2-2.2-2.3C4 16 4.7 15.2 5 14z" />
    </>
  ),
  parafrase: (
    <>
      <path d="M4 6h10M4 10h8M4 14h6" />
      <path d="M14 17h7M18 13l4 4-4 4" />
    </>
  ),
  konsistensi: (
    <>
      <path d="M4 7h16M4 12h16M4 17h16" />
      <circle cx="8" cy="7" r="2" fill="var(--surface,#fff)" />
      <circle cx="15" cy="12" r="2" fill="var(--surface,#fff)" />
      <circle cx="11" cy="17" r="2" fill="var(--surface,#fff)" />
    </>
  ),
  validasi: (
    <>
      <path d="M12 3 20 7v6c0 4.5-3.2 7.3-8 9-4.8-1.7-8-4.5-8-9V7z" />
      <path d="m8 12 2.5 2.5L16 9" />
    </>
  ),
  sinkronisasi: (
    <>
      <path d="M20 8a8 8 0 0 0-13-3L4 8" />
      <path d="M4 4v4h4M4 16a8 8 0 0 0 13 3l3-3" />
      <path d="M20 20v-4h-4" />
    </>
  ),
  history: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2M3 12H1M4.5 6.5 3 5" />
    </>
  ),
  snapshot: (
    <>
      <rect x="4" y="5" width="16" height="14" rx="2" />
      <path d="m7 16 3-3 2 2 3-4 3 5" />
      <circle cx="9" cy="9" r="1.2" />
    </>
  ),
  docx: (
    <>
      <path d="M6 3h9l4 4v14H6z" />
      <path d="M15 3v5h5M9 11h7M9 15h7M9 19h5" />
      <path d="M3 9v9" />
    </>
  ),
  pdf: (
    <>
      <path d="M6 3h9l4 4v14H6z" />
      <path d="M15 3v5h5M9 16c2-5 4-7 5-4 .8 2-3 5-5 4 3-1 6-1 8 0" />
    </>
  ),
  download: (
    <>
      <path d="M12 3v12M7 11l5 5 5-5" />
      <path d="M4 19v2h16v-2" />
    </>
  ),
  finalisasi: (
    <>
      <path d="M5 4h14v17H5z" />
      <path d="m8 12 2.5 2.5L16 9M9 6h6M9 18h6" />
    </>
  ),
  payment: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="3" />
      <path d="M3 9h18M7 15h4M17 14v2" />
    </>
  ),
  license: (
    <>
      <path d="M5 4h14v16H5zM8 8h8M8 12h5" />
      <path d="m13 17 2 2 4-5" />
    </>
  ),
  security: (
    <>
      <path d="M12 3 20 7v6c0 4.5-3.2 7.3-8 9-4.8-1.7-8-4.5-8-9V7z" />
      <path d="M9 12v-2a3 3 0 0 1 6 0v2M8 12h8v5H8z" />
    </>
  ),
  admin: (
    <>
      <circle cx="12" cy="8" r="3" />
      <path d="M6 20v-2a6 6 0 0 1 12 0v2M19 4v4M17 6h4" />
    </>
  )
};

export function SenoIcon({
  name,
  title,
  ...props
}: SVGProps<SVGSVGElement> & { name: SenoIconName; title?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      {...props}
    >
      {title ? <title>{title}</title> : null}
      {paths[name]}
    </svg>
  );
}
